import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SideMenu from '../../components/sideMenu/SideMenu';
import FormAttendanceReview from './FormAttendanceReview';

const menus = [
  {
    id: 1,
    title: 'Absen Masuk',
    name: 'clock-in',
    icon: 'schedule',
    allowedRoles: ['1024'],
  },
  {
    id: 2,
    title: 'Absen Pulang',
    name: 'clock-out',
    icon: 'schedule',
    allowedRoles: ['1024'],
  },
];

const AttendanceSideMenu = ({ togglePopup, refetch }) => {
  const [selectedMenu, setSelectedMenu] = useState('clock-in');

  const handleMenu = (name) => {
    setSelectedMenu(name);
  };

  const selectedContent = (
    <>
      {selectedMenu === 'clock-in' && (
        <FormAttendanceReview {...{ togglePopup, refetch }} requestType="clock-in" />
      )}
      {selectedMenu === 'clock-out' && (
        <FormAttendanceReview {...{ togglePopup, refetch }} requestType="clock-out" />
      )}
    </>
  );

  return (
    <SideMenu
      title=""
      desc=""
      menus={menus}
      content={selectedContent}
      selectedMenu={selectedMenu}
      handleMenu={handleMenu}
      inPopup
    />
  );
};

AttendanceSideMenu.propTypes = {
  togglePopup: PropTypes.func,
  refetch: PropTypes.func,
};

export default AttendanceSideMenu;
